(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[960],{

/***/ 118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talks",
      function () {
        return __webpack_require__(4752);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ talks; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(7985);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./layouts/ContentLayout.js
var ContentLayout = __webpack_require__(7830);
;// CONCATENATED MODULE: ./data/talks.json
var talks_namespaceObject = JSON.parse('[{"link":"https: //youtu.be/JhokA9fWVo0","lang":"en","content":{"title":"Building the Next Generation of Airlines Websites","where":"NextJS Conf 2020","publishedAt":"2020-11-07","duration":"25:18","tags":["Digital-Transformation"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1638394849/io-dot-com/conferences/nextjsconf2020_thumb_hgcztp.jpg","article":"","new":false,"active":true}},{"link":"https: //youtu.be/JhokA9fWVo0","lang":"es","content":{"title":"Construyendo la próxima generación de sitios web de aerolíneas","where":"NextJS Conf 2020","publishedAt":"2020-11-07","duration":"25:18","tags":["Digital-Transformation"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1638394849/io-dot-com/conferences/nextjsconf2020_thumb_hgcztp.jpg","article":"","new":false,"active":true}},{"link":"https://youtu.be/VMUMJadTauc","lang":"en","content":{"title":"Web Performance 101 in 2021","where":"Globant Tech Talk","publishedAt":"2021-02-09","duration":"01:04:12","tags":["Performance"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1638394849/io-dot-com/conferences/webperf101_thumb_a4ltwt.jpg","article":"","new":false,"active":true}},{"link":"https://youtu.be/VMUMJadTauc","lang":"es","content":{"title":"Web Performance 101 en el 2021","where":"Globant Tech Talk","publishedAt":"2021-02-09","duration":"01:04:12","tags":["Performance"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1638394849/io-dot-com/conferences/webperf101_thumb_a4ltwt.jpg","article":"","new":false,"active":true}},{"link":"https://youtu.be/cKZcAnA35To","lang":"en","content":{"title":"Observability 101: Monitoring your app is not about devops","where":"WebConf LATAM 2021","publishedAt":"2021-08-23","duration":"18:32","tags":["Observability"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1638394849/io-dot-com/conferences/webconf2021_thumb_xmc5nj.jpg","article":"","new":false,"active":true}},{"link":"https://youtu.be/cKZcAnA35To","lang":"es","content":{"title":"Observability 101: Monitorear tu app no es solo cosa de devops","where":"WebConf LATAM 2021","publishedAt":"2021-08-23","duration":"18:32","tags":["Observability"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1638394849/io-dot-com/conferences/webconf2021_thumb_xmc5nj.jpg","article":"","new":false,"active":true}},{"link":"https://youtu.be/oZO8nrradp4","lang":"en","content":{"title":"Interview with \\"Conversando Con Globers\\" (CCG) Season 1 BonusTrack","where":"Conversando con Globers","publishedAt":"2021-02-02","duration":"43:10","tags":["Interviews"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1639416921/io-dot-com/conferences/ccg-season1-bt_thumb_a8ze2u.jpg","article":"","new":false,"active":true}},{"link":"https://youtu.be/oZO8nrradp4","lang":"es","content":{"title":"Entrevista en \\"Conversando Con Globers\\" (CCG) Temporada 1 BonusTrack","where":"Conversando con Globers","publishedAt":"2021-02-02","duration":"43:10","tags":["Interviews"],"image":"https://res.cloudinary.com/iolivares-photos/image/upload/c_fill,w_800,g_face/v1639416921/io-dot-com/conferences/ccg-season1-bt_thumb_a8ze2u.jpg","article":"","new":false,"active":true}}]');
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./lib/dates.js
var dates = __webpack_require__(7426);
// EXTERNAL MODULE: ./components/ExternalLink.js
var ExternalLink = __webpack_require__(3778);
;// CONCATENATED MODULE: ./components/TalksList.js







function TalksList(param) {
    var talks = param.talks;
    var locale = (0,router.useRouter)().locale;
    var t = (0,esm/* useTranslation */.$G)('talks').t;
    return(/*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("article", {
        className: "mt-6 mb-10 sm:mb-20",
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
            className: "max-w-6xl mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("h2", {
                    className: "mb-8 title-font text-2xl lg:text-3xl xl:text-4xl font-bold tracking-tighter text-left text-gray-800 dark:text-gray-100",
                    children: [
                        "🎙 ",
                        t('talks-all-title')
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                    className: "flex flex-wrap",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                        className: "w-full list-none sm:divide-y sm:divide-gray-100 dark:sm:divide-gray-600",
                        children: talks.map(function(talk, index1) {
                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("li", {
                                className: "py-2",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ExternalLink/* default */.Z, {
                                    href: talk.link,
                                    classNames: "w-full py-2 sm:flex items-start px-4 rounded-md group md:hover:bg-gray-100 md:dark:hover:bg-gray-800 motion-safe:transition-all motion-safe:duration-300",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            className: "shrink-0 mb-4 sm:mb-0 sm:mr-4 text-center md:text-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("picture", {
                                                className: "inline-flex rounded-lg overflow-hidden",
                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                                    alt: talk.content.title,
                                                    src: talk.content.image,
                                                    className: "w-full responsive object-cover rounded-md sm:h-32 sm:w-32 motion-safe:transform motion-safe:duration-300 group-hover:scale-110",
                                                    layout: "intrinsic",
                                                    width: 227,
                                                    height: 128
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("h3", {
                                                    className: "mt-3 text-xl text-neutral-600 lg:text-2xl font-medium leading-6 text-primary-500 dark:text-primary-300 group-hover:text-primary-400 group-hover:dark:text-primary-50",
                                                    children: talk.content.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                    className: "flex flex-wrap items-start mt-2",
                                                    children: [
                                                        talk.content.tags.map(function(tag, index) {
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                                className: "bg-gray-300 text-gray-800 text-xs font-medium tracking-wide uppercase inline-flex items-center px-2.5 py-0.5 mr-2 mb-2 md:mb-1 rounded-md",
                                                                children: tag
                                                            }, index);
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                            className: "text-gray-800 dark:text-gray-100 text-sm font-medium inline-flex items-center mr-2 mb-2 md:mb-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    className: "h-4 w-4 mr-1 text-gray-800 dark:text-gray-100",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round",
                                                                            strokeWidth: "2",
                                                                            d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round",
                                                                            strokeWidth: "2",
                                                                            d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                                                        })
                                                                    ]
                                                                }),
                                                                talk.content.where
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                            className: "text-gray-800 dark:text-gray-100 text-sm font-medium inline-flex items-center mr-2 mb-2 md:mb-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    className: "h-4 w-4 mr-1 text-gray-800 dark:text-gray-100",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        strokeWidth: "2",
                                                                        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                                    })
                                                                }),
                                                                (0,dates/* formatDate */.p6)((0,parseISO/* default */.Z)(talk.content.publishedAt), locale)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                            className: "text-gray-800 dark:text-gray-100 text-sm font-medium inline-flex items-center mb-2 md:mb-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    className: "h-4 w-4 mr-1 text-gray-800 dark:text-gray-100",
                                                                    fill: "none",
                                                                    viewBox: "0 0 24 24",
                                                                    stroke: "currentColor",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        strokeWidth: "2",
                                                                        d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                                    })
                                                                }),
                                                                talk.content.duration
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index1);
                        })
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/LatestItem.js
var LatestItem = __webpack_require__(8062);
;// CONCATENATED MODULE: ./pages/talks.js








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Talks = function(props) {
    var locale = (0,router.useRouter)().locale;
    var t1 = (0,esm/* useTranslation */.$G)('talks').t;
    var talksOrdered = talks_namespaceObject === null || talks_namespaceObject === void 0 ? void 0 : talks_namespaceObject.filter(function(talk) {
        return talk.lang === locale;
    }) // Filter to get by locale
    .sort(function(a, b) {
        return(// Sort talks by date
        (0,parseISO/* default */.Z)(b.content.publishedAt) - (0,parseISO/* default */.Z)(a.content.publishedAt));
    }).filter(function(t) {
        return t.content.active;
    }) // Just the active ones
    ;
    var lastTalk = talksOrdered.slice(0, 1)[0];
    var allTalks = talksOrdered.slice(1, talks_namespaceObject.length - 1);
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ContentLayout/* default */.Z, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                dangerouslySetInnerHTML: {
                    __html: t1('talks-single', {
                        interpolation: {
                            escapeValue: false
                        }
                    })
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LatestItem/* default */.Z, {
                item: lastTalk,
                dict: "talks"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TalksList, {
                talks: allTalks
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                children: t1('talks-endline')
            })
        ]
    })));
};
var __N_SSG = true;
/* harmony default export */ var talks = (Talks);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [22,477,276,888,179], function() { return __webpack_exec__(118); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);